import React, { Component } from 'react';
import './employee.css';
import { featuredImage, employeeRoles } from "../../utilities";
import anonymousPicture from '../randomEmployee/anonymous.png';
import has from 'lodash.has';
import get from 'lodash.get';

class Employee extends Component {

    constructor(props) {
        super(props);

        this.triggerIt = this.triggerIt.bind(this);
    }

    render() {
        let roles = employeeRoles(this.props.employee);
        let picture = featuredImage(this.props.employee, "medium") ? featuredImage(this.props.employee, "medium_large") : anonymousPicture;

        let telephonenumber = has(this, 'props.employee.employeedetails[0].mobiel_nr') && get(this, 'props.employee.employeedetails[0].mobiel_nr') ? (<div className="employee__telephonenumber">{ get(this, 'props.employee.employeedetails[0].mobiel_nr') }</div>) : '';
        return (
            <div className="employee">
                <div className={this.props.triggered ? "employee__details employee__details--triggered" : "employee__details"}>
                    <div className="employee__detailswrapper">
                        <div className="employee__detailscontact">
                            <div className="employee__close" onClick={this.triggerIt}>Sluit</div>
                            <div className="employee__name employee__name--detailed" dangerouslySetInnerHTML={{__html: this.props.employee.title.rendered}} />
                            <div className="employee__role--detailed">{ roles.join(', ') }</div>
                            <div className="employee__emailaddress">{ ( this.props.employee.employeedetails && this.props.employee.employeedetails[0] && this.props.employee.employeedetails[0].emailadres ) ? this.props.employee.employeedetails[0].emailadres : "" }</div>
                            {telephonenumber}
                        </div>
                        <div className="employee__kwoot" dangerouslySetInnerHTML={{__html: this.props.employee.content.rendered}} />
                    </div>
                </div>
                <div className={this.props.triggered ? "employee__main employee__main--triggered" : "employee__main"} onClick={this.triggerIt}>
                    <img className="employee__image" alt={this.props.employee.title.rendered} src={ picture }/>
                    <div className="employee__name" dangerouslySetInnerHTML={{__html: this.props.employee.title.rendered}} />
                    <div className="employee__role">{ roles.join(', ') }</div>
                </div>
            </div>
        );
    }

    triggerIt() {
        this.props.onEmployeeTrigger(this.props.employee);
    }
}

export default Employee;



// WEBPACK FOOTER //
// ./src/components/employee/employee.js